import PropTypes from "prop-types";
import React from "react";
import { COURTED_ATTRIBUTES_SHAPE, SECTION_DEFS } from "./courtedConstants";
import { Section } from "./Section";
import { SectionSeparator } from "./SectionSeparator";

const CourtedSections = ({ attrs, sections }) => {
  const visibleSections = SECTION_DEFS.filter((def) => sections[def.key]);

  return (
    <>
      {visibleSections.map((def, index) => (
        <React.Fragment key={def.key}>
          {index > 0 && <SectionSeparator />}
          <Section def={def} attrs={attrs} />
        </React.Fragment>
      ))}
    </>
  );
};

CourtedSections.propTypes = {
  attrs: COURTED_ATTRIBUTES_SHAPE.isRequired,
  sections: PropTypes.objectOf(PropTypes.bool).isRequired,
};

export default CourtedSections;
